<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="SysMerLoginlog" ref="queryForm" label-width="auto" size="small" inline>




        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item :label="$t('startDate')" prop="startTime">
            <el-date-picker
              v-model="SysMerLoginlog.startTime"
              type="datetime"
              :placeholder="$t('startDate')"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              class="full-width"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
        </el-col>


        <el-col :xs="24"
                :sm="12"
                :md="12"
                :lg="{span:8,offset:8}"
                :xl="{span:6,offset:12}">
          <el-form-item :label="$t('endDate')" prop="endTime">
            <el-date-picker
              v-model="SysMerLoginlog.endTime"
              type="datetime"
              :placeholder="$t('endDate')"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              :picker-options="endPickerOptions"
              class="full-width"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item
            :label="$t('forwardLoginLogList.adminid')"
            prop="maMerLgginAccount"
          >
            <div class="input-with-more">
              <el-input v-model="SysMerLoginlog.maMerLgginAccount" clearable />
            </div>
          </el-form-item>
        </el-col>



        <el-col :xs="24"
                :sm="12"
                :md="12"
                :lg="{span:8,offset:8}"
                :xl="{span:6,offset:12}">
          <el-form-item
            :label="$t('forwardLoginLogList.status')"
            prop="status"

          >
            <el-select
              v-model="SysMerLoginlog.mlStatus"

              clearable
              filterable
              style="width: 100%;"
            >
              <el-option
                :label="$t('forwardLoginLogList.success')"
                value="1"
              />

              <el-option
                :label="$t('forwardLoginLogList.fail')"
                value="0"
              />

            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>


      </el-form>
    </el-card>

    <div class="action-toolbar">


    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >



        <el-table-column prop="maMerLgginAccount"  :label="$t('forwardLoginLogList.adminid')" :min-width="columnWidths.adminid"></el-table-column>
        <el-table-column prop="maName"  :label="$t('forwardLoginLogList.syslogname')" :min-width="columnWidths.syslogname"></el-table-column>
        <el-table-column prop="mlIp"  :label="$t('forwardLoginLogList.syslogip')" :min-width="columnWidths.syslogip"></el-table-column>

        <el-table-column prop="mlDate"  :label="$t('forwardLoginLogList.logintime')" :min-width="columnWidths.logintime"></el-table-column>

        <el-table-column :label="$t('forwardLoginLogList.status')" :min-width="columnWidths.status">
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row.mlStatus === 1 ? '' : '#F56C6C'
              }"
            >
            {{ scope.row.mlStatus === 1
                    ? $t('forwardLoginLogList.success')
                    : $t('forwardLoginLogList.fail')
                    }}
    </span>
          </template>
        </el-table-column>

        <el-table-column prop="mlFailureReason"  :label="$t('forwardLoginLogList.failreason')" :min-width="columnWidths.failreason"></el-table-column>



      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>

  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.SysMerLoginlog.startTime) {
            return false;
          }

          return (
            time.getTime() <
            new Date(this.SysMerLoginlog.startTime).getTime()
          );
        }
      },
      loading: false,
      SysMerLoginlog: {
        startTime: "",
        endTime: "",
        maMerLgginAccount: "",

        sortField: undefined,
        sortOrder: undefined
      },

      moreDialogVisible: false,

      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询



      checkAllCurrency: false,

      updateLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",


    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
    this.setDefaultTime(); //时间设置
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  methods: {
    setDefaultTime() {
      const now = new Date();

      // 当天开始时间
      const start = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      );

      // 当天结束时间
      const end = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59
      );

      this.SysMerLoginlog.startTime = this.formatDateTime(start);
      this.SysMerLoginlog.endTime = this.formatDateTime(end);
    },
    formatDateTime(date) {
      const pad = (n) => String(n).padStart(2, '0');

      return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
      );
    },
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.SysMerLoginlog.sortField = undefined;
        this.SysMerLoginlog.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.SysMerLoginlog.sortField = prop;
        this.SysMerLoginlog.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },



    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          startTime : this.SysMerLoginlog.startTime || undefined,
          endTime : this.SysMerLoginlog.endTime || undefined,
          mlStatus : this.SysMerLoginlog.mlStatus || undefined,
          maMerLgginAccount : this.SysMerLoginlog.maMerLgginAccount || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/loginlog/merlist',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowId = row.tsId;

    },



    // 表头宽度
    initColumnWidths() {
      const cols = [
        "adminid",
        "syslogname",
        "syslogip",
        "logintime",
        "status",
        "failreason",

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `SysMerLoginlog.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}


/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}



</style>



// WEBPACK FOOTER //
// src/view/log/forwardLoginLogList.vue